import { render, staticRenderFns } from "./Model15.vue?vue&type=template&id=6b8d73d8&scoped=true&"
import script from "./Model15.vue?vue&type=script&lang=js&"
export * from "./Model15.vue?vue&type=script&lang=js&"
import style0 from "./Model15.vue?vue&type=style&index=0&id=6b8d73d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8d73d8",
  null
  
)

export default component.exports